export function clickOutside(
	node: HTMLElement,
	param: ((e: Event) => void) | [(e: Event) => void, HTMLElement[]]
) {
	let handler: (e: Event) => void
	let ignore: HTMLElement[] = []

	if (Array.isArray(param)) {
		handler = param[0]
		ignore = param[1] ?? []
	} else {
		handler = param
	}

	function onClick(event: MouseEvent) {
		const target = event.target as Node

		if (node.contains(target)) return

		for (const el of ignore) {
			if (el && el.contains(target)) return
		}

		handler(event)
	}

	document.addEventListener('click', onClick, true)

	return {
		destroy() {
			document.removeEventListener('click', onClick, true)
		}
	}
}
